import router from './router'
import SafeMessages from './localization'

export default {
  router,
  localization: SafeMessages,
}
